export default __webpack_public_path__ + "static/media/july.9672e438.png";